var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-tooltip',{attrs:{"icon":"","tooltip":_vm.$t('common.filter')},on:{"click":_vm.showFilter}},[_c('v-icon',{attrs:{"size":"20","color":_vm.hasFilter ? 'accent' : 'txtSecondary'}},[_vm._v(" "+_vm._s(_vm.hasFilter ? 'mdi-filter' : 'mdi-filter-outline')+" ")])],1),_c('filter-coach-dialog',{ref:"filter"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }